import Vue from 'vue'

const eventBus = new Vue()

function showToastSuccess(message) {
  eventBus.$emit('showToast', { icon: 'mdi-check-circle-outline', type: 'success', message })
}

function showToastError(message) {
  eventBus.$emit('showToast', { icon: 'mdi-block-helper', type: 'error', message })
}

function showConfirmationMenu(callOpts) {
  eventBus.$emit('showConfirmationMenu', callOpts)
  return new Promise(resolve => {
    eventBus.$once('confirmationAccept', data => resolve(data.value))
  })
}

export { showToastSuccess, showToastError, showConfirmationMenu }
export default eventBus
